<template>
  <span>
    <el-tooltip class="item" effect="dark" content="Send invoice by number" placement="top-start">
      <el-button
          id="btn-send-invoice-number"
          type="primary"
          @click="dialogVisible = true"
          size="mini"
      >
        Send invoice by number
      </el-button>
    </el-tooltip>
    <el-dialog
        v-on:open="handleOpen"
        title="Send invoice by number"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="25%"
        append-to-body
        class="dialog-with-cols"
    >
      <el-form :model="form" ref="form" label-position="top" size="mini">
        <el-row>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
            <el-form-item label="Invoice number" prop="number">
               <el-input style="width: 160%!important;"
                   v-model="form.number"
                   v-alphanumeric-validation
                   clearable
                   class="inline-input"
               ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
        <el-button
            type="primary"
            id="form-save-button"
            @click="handleSearch"
            size="mini"
            :disabled="!form.number"
        >
          Send
        </el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import accountService from '@/api/accountService';

export default {
  name: 'SendInvoiceNumber',
  components: {
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        number: null
      },
    };
  },
  methods: {
    handleOpen() {
      this.resetForm();
    },
    async handleSearch() {
      Message.closeAll();

      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      accountService.sendInvoiceByNumber(this.form.number)
        .then((response) => {
          this.$message.success(response.message);
        }).catch((error) => {
          this.$message.error(error.message);
        }).finally(() => {
          loading.close();
        });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.date = null;
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
